import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M9.5 9.5a4.75 4.75 0 1 0 0-9.5 4.75 4.75 0 0 0 0 9.5m0-7.917a3.167 3.167 0 1 1 0 6.334 3.167 3.167 0 0 1 0-6.334m0 9.5a7.133 7.133 0 0 0-7.125 7.125.792.792 0 1 0 1.583 0 5.542 5.542 0 1 1 11.084 0 .792.792 0 1 0 1.583 0A7.133 7.133 0 0 0 9.5 11.083" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h19v19H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }